var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.5@lodash/_nativeCreate.js
// module id = 95
// module chunks = 0 1